import { Controller } from "stimulus";
import MicroModal from "micromodal";

export default class extends Controller {
  initialize() {
    MicroModal.show("daily-action-review");
  }
}
